import gsap, { Power2 } from 'gsap';
import { Noise } from 'noisejs';

import { GetBy } from "../_app/cuchillo/core/Element";
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Maths } from '../_app/cuchillo/utils/Maths';

export class WaveSemiCircle {
    container;
    path;
    speed = 0;
    noise;
    width = 0;
    height = 0;
    options = {
        frequency: Math.random() * (0.008 - 0.001) + 0.001,
        amplitude: Math.random() * (35 - 25) + 25
    };
    radius = { x: 0, y: 0 };
    center = { x: 0, y: 0 };
    _multiplicator = 0;

    constructor(__svg, __opts = {}) {
        this.container = __svg;
        this.path = GetBy.selector('path', this.container)[0];

        this.options = {
            ...__opts,
            ...this.options,
        };

        this.noise = new Noise(Math.random());

        this.resize();
        this.generateSmoothCircleWave();
    }

    show(__d = 0) {
        gsap.killTweensOf(this._multiplicator);
        gsap.to(this, { _multiplicator: 1, duration: 1, delay: __d, ease: Power2.easeOut })
        gsap.to(this.container, { x: '0', duration: .5, delay: __d, ease: Power2.easeOut })
    }

    hide(__d = 0) {
        gsap.killTweensOf(this._multiplicator);
        gsap.to(this.container, { x: '100%', duration: .4, delay: __d, ease: Power2.easeOut })
        gsap.to(this, { _multiplicator: 0, duration: .4, delay: __d, ease: Power2.easeOut })
    }

    setupAttributes() {
        this.container.setAttribute('viewBox', `0 0 ${this.width} ${this.height}`);
        this.container.setAttribute('width', this.width);
        this.container.setAttribute('height', this.height);
    }

    calculateCircle() {
        this.radius = { x: this.width / 4, y: this.height / 4 };
        this.center = { x: this.width / 2, y: this.height / 2 };
    }

    generateSmoothCircleWave() {
        let pathData = `M ${this.width} 0 L ${this.width / 2} 0 `;

        for (let y = 0; y < this.height; y++) {
            let relY = 0;
            if (y <= this.center.y) {
                relY = Maths.normalize(this.center.y, 0, y);
            } else {
                relY = Maths.normalize(this.center.y, this.height, y);
            }

            const easedY = (1 - Math.pow(1 - relY, 3)) * this._multiplicator;
            const displaceX = Maths.lerp(this.width * .9, this.width * .45, easedY);

            const noiseValue = this.noise.perlin2(y * .0055, this.speed * 0.04);
            const variableAmplitude = this.options.amplitude * this._multiplicator * (0.5 + noiseValue);

            let animatedX = variableAmplitude * Math.sin(this.options.frequency * y + this.speed) + displaceX;
            const x = Math.min(animatedX, this.width);

            pathData += `L ${x} ${y}`;
        }

        pathData += `L ${this.width / 2} ${this.height} L ${this.width} ${this.height} Z`;
        this.path.setAttribute('d', pathData);
    }

    loop(__t) {
        this.speed = __t * .03;
        this.generateSmoothCircleWave();
    }

    dispose() {
        this.container = null;
        this.path = null;
    }

    resize() {
        const { height, width } = this.container.getBoundingClientRect();

        this.height = height;
        this.width = width;

        this.setupAttributes();
        this.calculateCircle();
    }
}
